import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomOrderHistoryState from "@tKgpco/Store/Data/OrderHistory/OrderHistoryStateExtension";
import { Draft } from "immer";

const initialState: CustomOrderHistoryState = {
    clearOrderHistoryFilters: false,
    getOrderHistoryParams: {},
};
export const reducer = {
    "Custom/OrderHistory/ClearFilters": (draft: Draft<CustomOrderHistoryState>, action: CustomOrderHistoryState) => {
        draft.clearOrderHistoryFilters = action.clearOrderHistoryFilters;
        draft.getOrderHistoryParams = action.getOrderHistoryParams;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
